module.exports = __webpack_public_path__ + "img/portrait_bg.d8ab8219.png";